// imports
import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';
import { Routes, Route, Navigate } from 'react-router-dom';

// views 
import MainView from 'Modules/dynamicForms/views/main';

import { HasPermission } from 'Core/security';

// router 
const routerReports = (props) => {
	const user = useSelector(state => state.securityRedux.user)
	return (
		<Routes>
			{
				//HasPermission(user, "nr", [21]) &&
				<Fragment>
					<Route path='/' element={<Navigate to="/app/dynamicforms/main" />}></Route>
					<Route path='main' element={<MainView />} />
				</Fragment>
			}
			<Route path="*" element={<Navigate to="/app/error" />} />
		</Routes>
	);
};

export default routerReports
